// AB test: starting_donation_on_frp_with_amount_page
// Can be removed when experiment has ended
import { DonationAmountContext } from '../context/DonationAmountContext';

import { useNotNullableContext } from './useNotNullableContext';

export const useDonationAmount = () =>
  useNotNullableContext(DonationAmountContext);
